import { Container, Typography, Box } from "@mui/material";

export default function AboutUs() {
  return (
    <Box sx={{ py: 10 }}>
      <Container>
        <Typography color="primary" gutterBottom>
          WHAT WE DO
        </Typography>

        <Typography variant="h4" gutterBottom>
          About Us
        </Typography>

        <Typography color="grey.400" maxWidth="2000px">
          Nerdshub delivers digital transformation and technology services from ideation to execution, enabling global companies to move up the value chain. A strong blend of expertise and execution with passion, Nerdshub delivers quality experiences while driving greater efficiency and modernizing business operations. We work with people and organizations who have ambitious missions by setting up smart teams that love challenges and think disruptively to help our clients succeed.
We offer the most cost-effective, secure, and scalable models to service our clients across various verticals such as banking, hi-tech, education, and entertainment, to name a few. We engineer meaningful technology solutions to help businesses and societies move from good to great. Our innovations have allowed us to provide an SLA of anywhere from 0~24 hours and the ability to scale over 1,000+ apps a day.
Nerdshub was formed in 2002 by a team of highly qualified and experienced professionals from the enterprise software world. The management team, collectively having over 100 years of experience, came together with the goal of leveraging their international industry experience to build a global, comprehensive services organization with the highest quality of services. We are a software company and a group of passionate, purpose-led individuals who believe in developing true partnerships.
        </Typography>
      </Container>
    </Box>
  );
}
